'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { ACHName } from '@sola/ark-core/molecules/ach-fields/ach-name.tsx';
import { InputField } from '@sola/ark-core/molecules/input-field/input-field.tsx';
import { PAYMENT_METHOD_NICKNAME_MAX_LENGTH, SupporterAchFieldsEnum } from '@sola/schema/dotcom/supporters/paymentMethods.ts';
import { GraphQLSupporterPaymentMethod } from '@sola/schema/dotcom/supporters/schema.generated.ts';
export interface UpdateACHFields {
  paymentMethod: GraphQLSupporterPaymentMethod;
}
export const UpdateACHFields: React.FC<UpdateACHFields> = t0 => {
  const $ = _c(13);
  const {
    paymentMethod
  } = t0;
  const {
    t
  } = useTranslation("my");
  const t1 = paymentMethod.ach?.accountName;
  let t2;
  if ($[0] !== t1) {
    t2 = <ACHName name={SupporterAchFieldsEnum.accountName} value={t1} required={true} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t) {
    t3 = t("payments.methodForm.fieldLabels.achNickname");
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = paymentMethod.accountNickname;
  let t5;
  if ($[4] !== t) {
    t5 = t("payments.methodForm.fieldLabels.optional");
    $[4] = t;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== paymentMethod.accountNickname || $[7] !== t3 || $[8] !== t5) {
    t6 = <InputField name={SupporterAchFieldsEnum.nickname} label={t3} value={t4} hint={t5} maxLength={PAYMENT_METHOD_NICKNAME_MAX_LENGTH} />;
    $[6] = paymentMethod.accountNickname;
    $[7] = t3;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t2 || $[11] !== t6) {
    t7 = <>{t2}{t6}</>;
    $[10] = t2;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};